import asJSONLDSnippet from './asJSONLDSnippet';

export default asJSONLDSnippet(({links}) => links.some(it => !!it.to) && ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: links.map(({name, to}, idx) => ({
    '@type': 'ListItem',
    position: idx + 1,
    name: name,
    ...(to && {item: `${process.env.PUBLIC_URL}${to}`.replace(/\/+$/, '')})
  }))
}));



// WEBPACK FOOTER //
// ./components/JSON-LD/JSONLDBreadcrumbs.js